module.exports = __webpack_public_path__ + "assets/img/users.09550beb.svg";